.ux-mobile-table__select {
  padding: 0 25px 20px;
  width: 100%;
}

.ux-mobile-table__accordion {
  @include font(light);

  font-size: $size-text-medium;
  margin: 0 0 10px;

  &-title {
    color: $color-black !important;
  }

  span {
    display: block;
    white-space: normal;
  }

  .ux-accordion__content-container {
    border-bottom: 0 !important;
    padding: 0 !important;
  }

  .ux-accordion__title-container {
    background-color: $color-blue-5;
    border-bottom: 1px solid $color-gray-border-dark;

    ux-icon[name="chevron-down"] {
      padding: 0 15px 0 10px;
    }

    ux-icon[name="square-info"] {
      padding-bottom: 2px;
    }
  }

  &-table {
    margin: 0 !important;
    width: 100% !important;
  }

  &-row {
    border-bottom: 1px solid $color-gray-border;
    display: block;
    padding: 20px 30px;
  }

  &-row:last-of-type {
    border-bottom: 0;
  }

  .ux-button {
    margin: 20px 0;
  }

  .ux-table__icon-text ux-icon {
    font-size: 26px;
    margin-left: 0;
  }
}
